// Hosts whose images need a signed URL before the browser can load them.
// Production serves documents from CloudFront, development from the
// self-hosted S3 endpoint; one build can cover both, so the list is a
// comma separated REACT_APP_* variable. When the variable is missing (jest,
// a build without the env file) the historical CloudFront host is used so
// production behaviour does not change.
const DEFAULT_SIGNED_IMAGE_HOSTS = ['d3p3b0rs4lnh2l.cloudfront.net'];

const readSignedImageHosts = () => {
    const raw = process.env.REACT_APP_SIGNED_IMAGE_HOSTS;
    if (typeof raw !== 'string' || raw.trim() === '') {
        return DEFAULT_SIGNED_IMAGE_HOSTS;
    }
    return raw
        .split(',')
        .map((host) => host.trim())
        .filter(Boolean);
};

export const SIGNED_IMAGE_HOSTS = readSignedImageHosts();

export const isSignedImageUrl = (url) => {
    if (typeof url !== 'string' || url === '') return false;
    return SIGNED_IMAGE_HOSTS.some((host) => url.includes(host));
};
